export default "__VITE_ASSET__DGNhLS79__"